export default ({...props}) => {
  const {palette, size, space, themeGrey, fontWeight, rem, rippleColor} =
    props.theme
  const {normal} = fontWeight

  return `
        box-shadow: none;
        font-weight: ${normal};
        font-size: ${rem(1.0625)};
        letter-spacing: ${space(-0.03875)}px;
        margin-bottom: 0px;
        display:flex;
        height: ${size(4.25)}px;
        & > span.text-elipsis {
            overflow: hidden;
            white-space: nowrap;
            display: block;
            text-overflow: ellipsis;
        }
        &[ap_type="primary"]{
            color: ${palette.common.white};
            background-color: ${palette.primary.main};
            &:hover{
                box-shadow: none;
                background-color:${palette.primary.dark};
            }
            &:focus {
                background-color: ${palette.primary.main};
                .MuiTouchRipple-root > * {
                    & > *{
                        background-color: ${palette.primary.dark};
                    }
                }
            }
            &[disabled]{
                background-color: ${themeGrey.input_disabled};
                color: ${themeGrey.disabled_grey};
            }
        }
        &[ap_type="secondary"]{
            color: ${palette.primary.main};
            border-color: ${palette.primary.main};

            &:hover {
                background-color:${palette.primary.light};
            }

            &:focus {
                background-color: ${palette.common.white};
                .MuiTouchRipple-root > * {
                    & > *{
                        background-color: ${rippleColor};
                    }
                }
            }
            
            &[disabled]{
                background-color: ${themeGrey.input_disabled};
                color: ${themeGrey.disabled_grey};
                border-color: ${themeGrey.input_disabled};
            }
        }
    `
}
